export enum CaseColumns {
  id,
  task,
  physician,
  pharmacy,
  payer,
  status,
  due,
}
